import { Box, SxProps, Typography } from "@mui/material";
import Markdown from "react-markdown";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { oneLight } from "react-syntax-highlighter/dist/esm/styles/prism";
import remarkGfm from "remark-gfm";

interface FormattedProps {
  children: string;
  sx?: SxProps;
}

const FormattedResponse = ({ children, sx }: FormattedProps) => {
  return (
    <Box sx={sx != null ? sx : null}>
      <Markdown
        remarkPlugins={[remarkGfm]}
        components={{
          p: Typography,
          code(props) {
            const { children, className, ref, ...rest } = props;
            const match = /language-(\w+)/.exec(className || "");
            return match ? (
              <SyntaxHighlighter
                {...rest}
                PreTag="div"
                language={match[1]}
                style={oneLight}
              >
                {String(children).replace(/\n$/, "")}
              </SyntaxHighlighter>
            ) : (
              <code
                {...rest}
                ref={ref}
                className={className}
                style={{
                  color: "#e01e5a",
                  backgroundColor: "rgba(29, 28, 29, 0.04)",
                  border: "1px solid rgba(29, 28, 29, 0.13)",
                  borderRadius: "3px",
                  padding: "2px 3px",
                }}
              >
                {children}
              </code>
            );
          },
        }}
      >
        {children}
      </Markdown>
    </Box>
  );
};

export default FormattedResponse;
